const Unauthorized = (thunkAPI, requestHeaders) => {
  const auth = thunkAPI.getState && thunkAPI.getState().auth;
  // Axios already retains the request Authorization context. Compare it in
  // place; do not copy bearer credentials into Redux actions or diagnostics.
  if (auth?.token) {
    const authorization = typeof requestHeaders?.get === "function"
      ? requestHeaders.get("Authorization")
      : requestHeaders?.Authorization || requestHeaders?.authorization;
    if (authorization !== `Bearer ${auth.token}`) return;
  }
  if (!auth || auth.isLoggedIn) {
    thunkAPI.dispatch({ type: "auth/authlogout" });
  }
};

export default Unauthorized;
